import React from 'react'
import Link, { withPrefix } from 'gatsby-link'
import 'babel-polyfill'

//  Components
import StateHeader from '../components/StateHeader/StateHeader.js'
import StateImpactTable from '../components/StateImpactTable/StateImpactTable.js'
import StateRankingTable from '../components/StateRankingTable/StateRankingTable.js';
import StateHighlights from '../components/StateHighlights/StateHighlights.js';
import StateCompare from '../components/Visualizations/containers/state-compare'
import StateChange from '../components/Visualizations/containers/state-change'
import Button from '../components/Button/Button.js'

class StateTemplate extends React.Component {
  render () {
    const { id, title, url } = this.props.pathContext

    return (
      <article>
        <StateHeader title={ title } id={ id } pathPrefix={this.props.data.site.pathPrefix} states={ this.props.data.allStatesJson.edges } />
        <div className="section">
          <div className="section__row section__row__2_up">
            <div className="section__content section__content__wide">
              <StateRankingTable state={ id } title={ title } />
            </div>
            <div className="section__content section__exhibit section__exhibit__padded section__content__narrow">
              <StateChange state={ id } />
            </div>
          </div>
        </div>
        <div className="section">
          <div className="section__row">
            <div className="section__content">
              <StateHighlights state={ id } />
            </div>
          </div>
        </div>
        <div className="section l-full">
          <div className="section__content section__exhibit section__exhibit__padded">
            <h2 className="section__exhibit__title">Comparison with the U.S. Average</h2>
            <StateCompare state={ id }  />
          </div>
        </div>
        <div className="section">
          <div className="section__content">
            <StateImpactTable state={ title }  />
          </div>
        </div>
        <div className="section section__downloads">
          <ul className="downloads__list">
            <li>
              <h3><strong>Download this State Profile as a PDF</strong></h3>
              <Button href={ withPrefix(`/files/${ title.replace(/ /g,"_") }.pdf`)} text="Download PDF" /></li>
            <li>
              <h3><strong>Want more? Check out our Data Center</strong></h3>
              <Button href="http://datacenter.commonwealthfund.org" text="Go to the Data Center" /></li>
          </ul>
        </div>
      </article>
    )
  }
}

export default StateTemplate

export const pageQuery = graphql`
  query StateTemplateQuery {
    site {
      pathPrefix
    }
    allStatesJson {
      edges {
        node {
          id
          title
          url
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/state.js